import { usePermittedQuery } from '@/hooks/usePermittedQuery'
import {
  getMyCurrentSlip,
  getMySlip,
  getMySlipView,
  listMyHistory,
} from '@/api/services/payroll-me.service'

export const myPayrollKeys = {
  all: () => ['my-payroll'] as const,
  current: () => ['my-payroll', 'current'] as const,
  slip: (slipId: string | null) => ['my-payroll', 'slip', slipId] as const,
  slipView: (slipId: string | null) =>
    ['my-payroll', 'slip-view', slipId] as const,
  history: (page?: number) => ['my-payroll', 'history', page] as const,
}

export function useMyCurrentSlip() {
  return usePermittedQuery({
    module: 'payroll',
    action: 'read_self',
    queryKey: myPayrollKeys.current(),
    queryFn: () => getMyCurrentSlip(),
    staleTime: 60_000,
  })
}

/** `slipId`: the history row's slipId (an org batch or a live payment). */
export function useMySlip(slipId: string | null) {
  return usePermittedQuery({
    module: 'payroll',
    action: 'read_self',
    queryKey: myPayrollKeys.slip(slipId),
    queryFn: () => getMySlip(slipId!),
    staleTime: 60_000,
    enabled: !!slipId,
  })
}

/** `slipId`: the history row's slipId (an org batch or a live payment). */
export function useMySlipView(slipId: string | null) {
  return usePermittedQuery({
    module: 'payroll',
    action: 'read_self',
    queryKey: myPayrollKeys.slipView(slipId),
    queryFn: () => getMySlipView(slipId!),
    staleTime: 60_000,
    enabled: !!slipId,
  })
}

export function useMyPayrollHistory(page = 1, limit = 10) {
  return usePermittedQuery({
    module: 'payroll',
    action: 'read_self',
    queryKey: myPayrollKeys.history(page),
    queryFn: () => listMyHistory({ page, limit }),
    staleTime: 60_000,
  })
}
